import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { WRxBase, isNotEmptyOrHiddenElement, propChanged } from '@wipo/w-angular/shared';
import { BehaviorSubject, Subject } from 'rxjs';

@Directive({
    host: {
        '[attr.disabled]': 'disabled ? true: undefined',
    },
    standalone: false
})
export abstract class WButtonBaseDirective extends WRxBase implements OnChanges {
  @Input() label: string = ''; // button label; used if buttonType = 'text' or 'tertiary'
  @Input() disabled: boolean = false; // button disabled
  protected abstract elementRef: ElementRef;
  empty = new BehaviorSubject(true);
  watchables = new Map<HTMLElement, Subject<boolean>>();
  ngOnChanges(changes: SimpleChanges): void {
    // skip in ssr
    if (this.elementRef.nativeElement && propChanged(changes, 'disabled')) {
      if (this.disabled) {
        // make sure this behaves cross browser
        this.elementRef.nativeElement.blur();
      }
    }
  }
  // watch HTML elements for their content
  isEmptyElement(el: HTMLElement): Subject<boolean> | undefined {
    if (!this.watchables.has(el)) {
      this.watchables.set(el, new Subject<boolean>());
      this.runOnMutation(el, { childList: true }, this.checkEmpty.bind(this, el));
      setTimeout(() => {
        this.checkEmpty(el);
      });
    }
    return this.watchables.get(el);
  }
  checkEmpty(el: HTMLElement) {
    const isNotEmpty = isNotEmptyOrHiddenElement(el);
    this.watchables.get(el)?.next(!isNotEmpty);
  }
}
